import {ApplicationRef, Injectable, Injector} from '@angular/core';

@Injectable()
export class FreezingErrorsDetector {
    private recentErrors: any = [];

    private timeout;
    private timeWindowMs = 300;
    private sameErrorsCountLimit = 5;

    constructor(private injector: Injector) {}

    public onErrorDetected: (e) => void;

    handleError(e: any) {
        if (e) {
            this.recentErrors.push(e);
        }
        const error = this.checkErrors();
        if (error) {
            return this.cyclicalErrorDetected(error);
        }
        if (!this.timeout) {
            this.timeout = setTimeout(() => {
                this.timeout = null;
                this.recentErrors = [];
            }, this.timeWindowMs);
        }
    }

    checkErrors() {
        if (this.recentErrors.length < 2) {
            return false;
        }
        let sameErrorsCount = 0;
        return this.recentErrors.find((error, index, ar) => {
            for (let i = index + 1; i < ar.length; i++) {
                if (ar[i].stack === error.stack) {
                    sameErrorsCount++;
                }
                if (sameErrorsCount === this.sameErrorsCountLimit) {
                    return error;
                }
            }
        });
    }

    cyclicalErrorDetected(error) {
        this.stopAngular();
        this.displayErrorMessage();
        if (this.onErrorDetected) {
            this.onErrorDetected(error);
        }
    }

    stopAngular() {
        const app = this.injector.get(ApplicationRef);
        app.tick = () => {};
    }

    displayErrorMessage() {
        document.body.innerHTML = document.getElementById('internalErrorTemplate').innerHTML;
    }
}
